'use strict';

import React, { Component } from 'react';
import    Chart from  './generic.jsx';

class HighChartElement extends Component{
    render() {
        return (
            <div style={this.props.StyleMenu}><Chart container={this.props.container} options={this.props.options}/></div>
        );
    }
};

class BarChartHighchart extends Component{
    renderChart() {}
    shouldComponentUpdate(nextProps, nextState) {
        // called to ask whether the component should be updated
        console.log("[INFO], barchart billl ;; shouldComponentUpdate ######################");
        return true;
    }
    componentWillReceiveProps() {
        // called after the props are updated
        var seriesVal = this.props.series;
        console.log("[INFO, BAR CHART BILL, componentWillReceiveProps]");
        //console.log(seriesVal);
    }

    render() {
        var chartOptions = {
            chart: {
                type: 'column',
                zoomType: 'x'
            },
            title: {
                text: this.props.graphName
            },
            subtitle: {
                text: ''
            },
            credits: {
                enabled: false
            },
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: { // don't display the dummy year
                    month: '%e. %b',
                    year: '%b'
                },
                title: {
                    text: 'Date'
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Watt Heure par Jour (Wh)'
                }
            },
            tooltip: {
                headerFormat: '<b>{series.name}</b><br>',
                pointFormat: '{point.x:%e %b}: {point.y} Wh'
            },

            plotOptions: {
                spline: {
                    marker: {
                        enabled: true
                    }
                }
            },
            series: this.props.series

        };

        var StyleMenu = {
            width: "90%",
            height: "50% ",
            margin: "0 auto",
            position: "relative"
        };

        return (<HighChartElement StyleMenu={StyleMenu} options={chartOptions} container={this.props.container}/>);
    }
};
export default BarChartHighchart

//module.exports = BarChartHighchart;
